// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes, Translate } from '@plesk/ui-library';

const Bytes = ({ children: bytes, ...props }) => {
    const i = bytes && Math.floor(Math.log(bytes) / Math.log(1024));
    const prefix = i ? <Translate content={`Bytes.${['kilo', 'mega', 'giga', 'tera'][i - 1]}`} /> : '';
    const suffix = <Translate content="Bytes.suffix" />;

    return (
        <span {...props}>{(bytes / Math.pow(1024, i)).toFixed(2)} {prefix}{suffix}</span>
    );
};

Bytes.propTypes = {
    children: PropTypes.number.isRequired,
};

export default Bytes;



// WEBPACK FOOTER //
// ./app/repair/Bytes.js